export const userList = {
    headers:[
        'ID','Name', 'Email', 'Mobile', 'Status'
    ],
    dataSets:[
        'id','name', 'email', 'mobile', 'status'
    ]
}

export const blogList = {
    headers:[
        'ID','Title', 'Author', 'Date', 'Status'
    ],
    dataSets:[
        'id','title', 'author', 'publishedDate', 'status'
    ]
};
